import { getNormalParams, FastApiAxiosInstance } from 'common/service/axiosInstances';

const dynamicCheckItemSetting = {
  getWorkFlow: async (projectId: string | number) => {
    const params = { ...getNormalParams('getWorkFlow'), projectId: Number(projectId) };
    const { data } = await FastApiAxiosInstance.get<any, ExtendAxioResponse>('/api/v1/rule/getWorkFlow', { params });
    return data;
    // return WORKFLOWS;
  },
  getFileType: async (projectId: string | number) => {
    const params = { ...getNormalParams('getFileType'), projectId: Number(projectId) };
    const { data } = await FastApiAxiosInstance.get<any, ExtendAxioResponse>('/api/v1/rule/getFileType', { params });
    return data;
    // return CHECK_ITEMS;
  },
  getLauncherOptions: async (projectId: string | number) => {
    const params = { ...getNormalParams('getLauncherOptions'), projectId: Number(projectId) };
    const { data } = await FastApiAxiosInstance.get<any, ExtendAxioResponse>('/api/v1/project/getLauncherOptions', {
      params,
    });
    return data;
  },
  // 获取对应
  getCheckItemConfig: async (checkItemType: string, fileType: string[], projectId: string | number) => {
    const params = {
      ...getNormalParams('getRule'),
      checkItemType,
      fileType: fileType[0],
      projectId: Number(projectId),
    };
    const { data } = await FastApiAxiosInstance.get<any, ExtendAxioResponse>('/api/v1/rule/getRule', { params });
    // return checkTabConfig;
    return data;
  },
};
export default dynamicCheckItemSetting;
